import {
    atomWithStorage as atomWithStorageGeneric,
    createJSONStorage,
} from 'jotai/utils';

import type { StorageKey } from '../types/Storage';

// See Jotai's atomWithStorage documentation: https://jotai.org/docs/utilities/storage
export function atomWithStorage<T>(
    key: StorageKey,
    initialValue: T,
    getOnInit: boolean = true,
) {
    return atomWithStorageGeneric<T>(
        key,
        initialValue,
        createJSONStorage<T>(() => localStorage),
        { getOnInit },
    );
}

export function atomWithWindowStorage<T>(
    key: StorageKey,
    initialValue: T,
    getOnInit: boolean = true,
) {
    return atomWithStorageGeneric<T>(
        key,
        initialValue,
        createJSONStorage<T>(() => sessionStorage),
        { getOnInit },
    );
}
